<template>
  <div class="sidebar-concurrent-wrap">
    <div
      v-if="!conversationUiFlags.isFetching"
      class="contact-conversation--list"
    >
      <div
        v-on-clickaway="closeDropdownConcurrentLabel"
        class="concurrent-wrap"
        @keyup.esc="closeDropdownConcurrentLabel"
      >
        <add-concurrent-label @add="toggleConcurrentLabels" />
        <woot-label
          v-for="concurrentLabel in activeConcurrentLabels"
          :key="concurrentLabel.id"
          :title="concurrentLabel.title"
          :description="concurrentLabel.description"
          :show-close="true"
          :color="concurrentLabel.color"
          variant="smooth"
          @click="removeConcurrentLabelFromConversation"
        />

        <div class="dropdown-wrap">
          <div
            :class="{ 'dropdown-pane--open': showSearchDropdownConcurrentLabel }"
            class="dropdown-pane"
          >
            <concurrent-label-dropdown
              v-if="showSearchDropdownConcurrentLabel"
              :account-concurrent-labels="accountConcurrentLabels"
              :selected-concurrent-labels="savedConcurrentLabels"
              @add="addConcurrentLabelToConversation"
              @remove="removeConcurrentLabelFromConversation"
            />
          </div>
        </div>
      </div>
    </div>
    <spinner v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'shared/components/Spinner';
import ConcurrentLabelDropdown from 'shared/components/ui/concurrentLabel/ConcurrentLabelDropdown';
import AddConcurrentLabel from 'shared/components/ui/dropdown/AddConcurrentLabel';
import { mixin as clickaway } from 'vue-clickaway';
import conversationConcurrentLabelMixin from 'dashboard/mixins/conversation/concurrentLabelMixin';

export default {
  components: {
    Spinner,
    ConcurrentLabelDropdown,
    AddConcurrentLabel,
  },

  mixins: [clickaway, conversationConcurrentLabelMixin],
  props: {
    conversationId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      selectedConcurrentLabels: [],
      showSearchDropdownConcurrentLabel: false,
    };
  },

  computed: {
    ...mapGetters({
      conversationUiFlags: 'conversationConcurrentLabels/getUIFlags',
      concurrentUiFlags: 'conversationConcurrentLabels/getUIFlags',
    }),
  },
  methods: {
    toggleConcurrentLabels() {
      this.showSearchDropdownConcurrentLabel =
        !this.showSearchDropdownConcurrentLabel;
    },
    closeDropdownConcurrentLabel() {
      this.showSearchDropdownConcurrentLabel = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-concurrent-wrap {
  margin-bottom: 0;
}
.contact-conversation--list {
  width: 100%;

  .concurrent-wrap {
    line-height: var(--space-medium);
    position: relative;

    .dropdown-wrap {
      display: flex;
      left: -1px;
      margin-right: var(--space-medium);
      position: absolute;
      top: var(--space-medium);
      width: 100%;

      .dropdown-pane {
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}

.error {
  color: var(--r-500);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-medium);
}
</style>

